import React from "react";
import { useCashclock } from "./hooks/useCashclock";
import TickerDisplay from "./components/TickerDisplay";
import ControlPanel from "./components/ControlPanel";
import ChargeTools from "./components/ChargeTools";
import ChargeList from "./components/ChargeList";

export default function App() {
  const {
    budgetId,
    mode,
    setMode,
    connected,
    period,
    charges,
    serverOffsetMs,
    pops,
    consumePop,
    setBudget,
    addCharge,
    deleteCharge,
  } = useCashclock();

  const cls = [
    "app",
    mode.kiosk ? "is-kiosk" : "",
    mode.led ? "is-led" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={cls}>
      <header className="app-header">
        {!mode.kiosk && (
          <span className="brand">
            cash<span className="brand-accent">clock</span>
          </span>
        )}
        <div className="header-meta">
          {budgetId && !mode.kiosk ? (
            <span className="budget-id" title="budget id (in URL)">
              #{budgetId}
            </span>
          ) : null}
          <button
            type="button"
            className={`mode-toggle ${mode.led ? "is-on" : ""}`}
            onClick={() => setMode({ led: !mode.led })}
            title="Toggle LED matrix display"
          >
            LED
          </button>
          <button
            type="button"
            className={`mode-toggle ${mode.kiosk ? "is-on" : ""}`}
            onClick={() => setMode({ kiosk: !mode.kiosk })}
            title="Toggle kiosk mode"
          >
            KIOSK
          </button>
          {!mode.kiosk && (
            <span className={`conn-dot ${connected ? "is-on" : ""}`} />
          )}
        </div>
      </header>

      <main className="ticker-wrap">
        <TickerDisplay
          period={period}
          charges={charges}
          serverOffsetMs={serverOffsetMs}
          pops={pops}
          onPopDone={consumePop}
          led={mode.led}
        />
      </main>

      {!mode.kiosk && (
        <section className="controls-grid">
          <ControlPanel period={period} onApply={setBudget} />
          <ChargeTools disabled={!period} onAdd={addCharge} />
          <ChargeList charges={charges} onDelete={deleteCharge} />
        </section>
      )}
    </div>
  );
}
